import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

import { WidgetComponent } from '../../types/widgets.types'
import { WidgetWrapper } from '../WidgetWrapper'

export const TodosWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_SUBSIDIES_APP_DEV_PATH,
    'subsidies',
    './TodosWidget',
    'subsidiesApp'
  )

  // @ts-expect-error: dynamic import
  const { ExposedTodosWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { ExposedTodosWidget: () => <></> }

  return (
    <WidgetWrapper {...widgetProps} isLoading={!isLoaded}>
      <ExposedTodosWidget />
    </WidgetWrapper>
  )
}
